import {Box, type BoxProps} from '@mui/material';
import type {ReactNode} from 'react';
import React from 'react';

export interface ModalContentProps extends BoxProps {
    /** Padding entfernen, wenn der Inhalt randlos sein soll */
    disablePadding?: boolean;
    children: ReactNode;
}

export function ModalContent({disablePadding, children, sx, ...rest}: ModalContentProps) {
    return (
        <Box
            {...rest}
            sx={{
                flex: 1,
                minHeight: 0,
                overflowY: 'auto',
                ...(disablePadding ? {} : {px: 2.75, py: 2.25}),
                ...sx,
            }}
        >
            {children}
        </Box>
    );
}